/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ws (ignored)
// module id = 8
// module chunks = 1